import { useContext } from 'react';
import ExperimentProviderContext from './ExperimentProviderContext';
import { Experiments } from './SharedTypes';

type Context = {
  currentExperiment?: string;
  experiments?: Experiments;
};

const useExperimentBucket = experiment => {
  const context = useContext<Context>(ExperimentProviderContext);
  const { experiments = {} } = context;

  const { isLoading = null, assignedBucket = null } =
    experiments[experiment] || {};

  return isLoading ? null : assignedBucket;
};

export default useExperimentBucket;
